module.exports = __webpack_public_path__ + "img/blue-loyalty.d2b7364.png";